import { Component } from '@angular/core';

@Component({
	selector: 'post-filter-list',
	templateUrl: 'post-filter-list.html'
})

export class PostFilterList{


	constructor()
	{

	}
}



// WEBPACK FOOTER //
// ./src/partials/post/post-filter-list/post-filter-list.ts